export const iconFontAwesomeTravelHotelTruckDroplet = (
	<i className="fa-solid fa-truck-droplet"></i>
);
